var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13V11ZM25.7071 12.7071C26.0976 12.3166 26.0976 11.6834 25.7071 11.2929L19.3431 4.92893C18.9526 4.53841 18.3195 4.53841 17.9289 4.92893C17.5384 5.31946 17.5384 5.95262 17.9289 6.34315L23.5858 12L17.9289 17.6569C17.5384 18.0474 17.5384 18.6805 17.9289 19.0711C18.3195 19.4616 18.9526 19.4616 19.3431 19.0711L25.7071 12.7071ZM6 13H25V11H6V13Z",
    fill: "#C6C2BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextEnergy);
export default __webpack_public_path__ + "static/media/nextEnergy.07ef0f41cf5dd7d07dc6c77f72e7e99d.svg";
export { ForwardRef as ReactComponent };